import { useState, useEffect } from 'react';
import Number from 'react-number-format';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';
import { utils } from 'ethers';
import { useModal } from 'react-simple-modal-provider';
import ButtonPrimary from './ButtonPrimary';
import LinkExternal from '../components/Link/LinkExternal';
import getNftContract from '../hooks/getNftContract';
import getNftAddress from '../hooks/getNftAddress';
import getRnctContract from '../hooks/getRnctContract';
import { useEagerConnect, useActiveWeb3React } from '../hooks/index';
import './Details.scss';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faPencil } from '@fortawesome/free-solid-svg-icons'
import * as S from '../store/selectors';
import { ipfsPrfix } from '../configs';


const attributes = [{
  trait_type: 'Surname',
  value: '-',
}, {
  trait_type: 'Background',
  value: '-',
}, {
  trait_type: 'Base',
  value: '-',
}, {
  trait_type: 'Body',
  value: '-',
}, {
  trait_type: 'Clothes',
  value: '-',
}, {
  trait_type: 'Head',
  value: '-',
}, {
  trait_type: 'Eyes',
  value: '-',
}, {
  trait_type: 'Mouth',
  value: '-',
}, {
  trait_type: 'Head Gear',
  value: '-',
}, {
  trait_type: 'Back Weapon',
  value: '-',
}, {
  trait_type: 'Right Hand Weapon',
  value: '-',
}, {
  trait_type: 'Left Hand Weapon',
  value: '-',
}, {
  trait_type: 'Glove & Weapon',
  value: '-',
}];


function DetailsTrait({ trait_type, value, onClick, isOwner }) {
  const traitsCount = useSelector(S.nft.getTraitsCount);
  const traits = useSelector(S.nft.getTraits);
  let procent = 0;
  if (trait_type !== 'Name' && value) {
    procent = (traits[trait_type][value] / 7777) * 100;
  }
  return (
    <div className="sel__res">
      <div className="sel__res-col sel__res-col--1">
        <span style={{ color: 'rgb(251, 189, 116)' }}>{trait_type}</span>
      </div>

      <div className="sel__res-col sel__res-col--2" style={{ color: 'rgb(251, 189, 116)' }}>
        {value} {trait_type !== 'Name' && <Number
          style={{ color: '#fff', display: 'inline-block', float: 'right', }}
          value={procent} prefix='(%' suffix=')'
          displayType={'text'} thousandSeparator={true}
          fixedDecimalScale={true} decimalScale={2}
        />}
        {(trait_type === 'Name' && isOwner) && <FontAwesomeIcon
          icon={faPencil}
          style={{ marginLeft: 'auto', float: 'right', cursor: 'pointer', }}
          onClick={onClick}
        />}
      </div>
    </div>
  );
}


function Details({ tokenId, }) {
  const { t } = useTranslation();
  const tokens = useSelector(S.nft.getTokens);

  const token = (tokens.length > 0) ? tokens[tokenId - 1] : {
    imageHash: '-',
    imageIpfs: '-',
    attributes,
  };

  const { open: openChangeNameModal } = useModal('ChangeNameModal');
  const triedEager = useEagerConnect();
  const context = useActiveWeb3React();
  const { library, chainId, account, active } = context;

  const blockNumber = useSelector(S.provider.getBlockNumber);

  const etherscan = `https://${chainId === 4 ? 'rinkeby.' : ''}etherscan.io`;

  const [owner, setOwner] = useState('-');
  const [name, setName] = useState('');
  const [unclaimedRnct, setUnclaimedRnct] = useState('0');

  const [isOwner, setIsOwner] = useState(false);
  useEffect(async () => {
    if (owner === account) {
      setIsOwner(true);
    } else {
      setIsOwner(false);
    }
  }, [active, owner, account]);

  useEffect(async () => {
    try {
      const contract = getNftContract(chainId, library);
      const contract3 = getRnctContract(chainId, library);
      if (contract) {
        const owner = await contract.rawOwnerOf(tokenId);
        setOwner(owner);

        const name = await contract.tokenName(tokenId);
        setName(name);

        const rnct = await contract3.accumulated(tokenId);
        const rnctTotal = parseFloat(utils.formatEther(rnct));
        setUnclaimedRnct(rnctTotal);
      }
    } catch (error) { }
  }, [blockNumber]);
  if (token && !token.isMinted)
    return (
      <div className="col-12 col-lg-10 offset-lg-1 col-xl-8 offset-xl-2" >
        <h2 className="title text-center mt-5" style={{ color: 'rgb(251, 189, 116)' }}>
          NOT MINTED TOKEN
        </h2>
      </div>
    );
  else
    return (
      <div className="col-12 col-lg-10 offset-lg-1 col-xl-8 offset-xl-2" >
        <p className="details__hash" style={{ marginBottom: '0px' }}>
          <span className="colored">HASH: </span>
          <a>{token ? token.imageHash : '-'}</a>
        </p>
        <p className="details__hash" style={{ marginBottom: '0px' }}>
          <span className="colored">IPFS: </span>
          <LinkExternal href={ipfsPrfix + token ? token.imageIpfs : ''}>{token ? token.imageIpfs : '-'}</LinkExternal>
        </p>
        <p className="details__owned" style={{ marginBottom: '0px' }}>
          <span className="colored">Owned by: </span>
          <LinkExternal href={etherscan + '/token/' + getNftAddress(chainId) + `?a=${owner}`}>{owner}</LinkExternal>
        </p>
        <p className="details__rnct">
          <span className="colored">Accumulated RNCT: </span>
          <Number
            style={{ color: 'rgb(251, 189, 116)', }}
            value={unclaimedRnct} suffix=' RNCT'
            displayType={'text'} thousandSeparator={true}
            fixedDecimalScale={true} decimalScale={6}
          />
        </p>
        <h2 className="title text-center mt-5" style={{ color: 'rgb(251, 189, 116)' }}>
          Traits
        </h2>
        <div className="">
          <DetailsTrait trait_type={'Name'} value={name} isOwner={isOwner}
            onClick={() => openChangeNameModal({
              tokenId, Surname: (token && token.traits.Surname) ? token.traits.Surname : ' Roborovski',
            })}
          />

          {token && token.attributes.map((item, index) => (
            <DetailsTrait {...item} key={index} />
          ))}
        </div>

        {/*<div className="details__popup">
        <form className="details__form">
          <p className="details__popup-title">Change name for Robokovski #3</p>
          <input type="text" className="details__input" />
          <div className="details__btn-group">
            <ButtonPrimary
              tag="button"
              label={t('Close')}
              style={{ fontSize: '1.3rem' }}
            />
            <ButtonPrimary
              tag="button"
              label={t('Change')}
              style={{ fontSize: '1.3rem' }}
            />
          </div>
        </form>
        </div>*/}
      </div>
    );
}

export default Details;
